import { Alarm, UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { DescriptionListItem } from '@hakimo-ui/hakimo/ui-elements';

export const alarmProperties = [
  'True Alarm Probability',
  'Alarm Type',
  'Alarm Time',
  'Source Entity',
  'Employee',
  'Employee Phone Number',
  'Location',
  'Alarm Local Time',
  'Alarm Source System',
  'Resolved At',
  'Time To Remediation (Seconds)',
  'Camera',
  'Access Card Number',
];

export function buildDLItems(
  data: Alarm | UnifiedAlarm
): DescriptionListItem[] {
  return alarmProperties
    .map((name) => ({
      name,
      value: getDLItemValue(data, name),
    }))
    .filter((item) => item.value);
}

function getDLItemValue(
  data: Alarm | UnifiedAlarm,
  name: typeof alarmProperties[number]
): string | number | undefined {
  if ('alarmStartTime' in data) {
    const event = data as UnifiedAlarm;
    switch (name) {
      case 'True Alarm Probability':
        return event.tap;
      case 'Alarm Time':
        return new Date(event.alarmStartTime).toLocaleString();
      case 'Source Entity':
        return event.cameraName;
      case 'Alarm Type':
        return event.alarm_type;
      case 'Alarm Source System':
        return event.alarm_source_system;
      case 'Location':
        if (!event.location) return;
        return event.location.name && event.location.description
          ? `${event.location.name}\n${event.location.description}`
          : event.location.name;
      default:
        return;
    }
  } else {
    const alarm = data as Alarm;
    switch (name) {
      case 'True Alarm Probability':
        return alarm.tap ?? '-';
      case 'Alarm Time':
        return new Date(alarm.timestamp).toLocaleString();
      case 'Alarm Local Time':
        if (alarm.localTime) {
          return new Date(alarm.localTime).toLocaleString();
        }
        return;
      case 'Time To Remediation (Seconds)':
        return alarm.timeToRemediationInSeconds;
      case 'Resolved At':
        if (alarm.resolvedAt) {
          return new Date(alarm.resolvedAt).toLocaleString();
        }
        return;
      case 'Location':
        if (alarm.location?.name && alarm.location?.description) {
          return `${alarm.location?.name}\n${alarm.location?.description}`;
        } else if (alarm.location?.name) {
          return alarm.location?.name;
        }
        return undefined;
      case 'Source Entity':
        return alarm.sourceEntity?.name;
      case 'Alarm Type':
        return alarm.type;
      case 'Alarm Source System':
        return alarm.sourceSystem;
      case 'Camera':
        return alarm.camera;
      case 'Employee':
        return alarm.employee?.name;
      case 'Employee Phone Number':
        return alarm.employee?.phoneNumber;
      case 'Access Card Number':
        return alarm.metadata?.badgeNumber;
      default:
        return;
    }
  }
}
